import styleInject from '../../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".CalendarGrid-module_calendarGrid__fI-yc th {\n  padding-bottom: 4px;\n  font-weight: 700;\n  font-size: 0.875rem;\n  line-height: 1.42;\n}";
var styles = {"calendarGrid":"CalendarGrid-module_calendarGrid__fI-yc"};
styleInject(css_248z);

export { styles as default };
